<template lang="pug">
  #admin-super-member-center-settings
    WtTile(ancestor)
      WtTile(vertical)
        WtTile(parent)
          WtTile(child :col="12")
            button.button(@click="openModal") Upload Member Delete Feed

      WtTile(vertical)
        WtTile(parent)
          WtTile(child :col="12")
            button.button(@click="cacheBuster") Cache Buster
    WtTile(ancestor :col="12")
      WtTile(parent vertical :col="12")
        WtTile.members-list-title(
          child
          :col="12"
          :is-loading="!membersLoaded && membersInitialLoadComplete"
        )
          MemberList(
            :member-response-object="adminMembersResponseObject"
            :initial-load-complete="membersInitialLoadComplete"
            @search="onSearch($event)"
            :fetch-action="fetchProgramMembers"
            edit-member-route-name="AdminSuperMemberCenterSettingsIndividual"
          )

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WtTile from "@@/WtTile/WtTile";
import MemberList from "@@/MemberCenterAdmin/MemberList";
import { dateUtilityMixin } from "@/mixins/dateUtilityMixin";

const SuperAdminMemberDeleteFeed = () =>
  import(
    /* webpackChunkName: "SuperAdminMemberDeleteFeed" */ "@@/SuperAdminDeleteQueue/SuperAdminMemberDeleteFeed"
  ).catch(() => {
    window.location.reload();
  });

export default {
  name: "AdminSuperMemberCenterSettings",

  components: {
    WtTile,
    MemberList
  },

  mixins: [dateUtilityMixin],

  data() {
    return {
      perPage: 5,
      searchQuery: ""
    };
  },

  computed: {
    ...mapGetters("program", [
      "adminMembersResponseObject",
      "membersLoaded",
      "membersInitialLoadComplete"
    ])
  },

  mounted() {
    this.fetchProgramMembers({});

    this.onSearch = this._.debounce(async query => {
      this.searchQuery = query;
      const response = await this.searchMembers({
        programId: this.$auth.user().programId,
        query: query,
        perPage: this.perPage
      });

      this.setAdminMembersResponseObject(response);
    }, 500);
  },

  methods: {
    ...mapActions("program", [
      "fetchMembers",
      "searchMembers",
      "setAdminMembersResponseObject"
    ]),

    fetchProgramMembers(payload) {
      Object.assign(payload, {
        programId: this.$auth.user().programId,
        perPage: this.perPage
      });

      if (this.searchQuery) {
        payload.query = this.searchQuery;
        return this.searchMembers(payload).then(response => {
          this.setAdminMembersResponseObject(response);
          return response;
        });
      }

      return this.fetchMembers(payload);
    },

    onSearch() {
      // defining this here, but is overwritten in the
      // mounted call.  Using debounce requires this
      // approach in order for it to work when
      // the component instance is available.
    },

    openModal() {
      this.$buefy.modal.open({
        parent: this,
        component: SuperAdminMemberDeleteFeed,
        hasModalCard: true
      });
    },

    cacheBuster() {
      this.$buefy.dialog.confirm({
        title: "for emergency use only",
        confirmText: "Yes",
        type: "is-danger",
        hasIcon: true,
        message: "are you sure you wish to do this?",
        onConfirm: async () => {
          this.axios
            .get(`cache-buster`)
            .then(response => {
              if (response && response.data.success) {
                this.$buefy.toast.open("CACHE BUSTED!");
              }
              console.log("response: ", response);
            })
            .catch(error => {
              this.$buefy.toast.open("try again...");
              console.log("error: ", error);
            });
        }
      });
    }
  }
};
</script>

<style lang="sass" scoped>
#admin-super-member-center-settings
  padding-bottom: 500px

  .members-list-title
    min-height: 300px
</style>
